
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Cabserviceintalegaon() {



const cardData = {
  keyword: 'Cab Service in Talegaon Dabhade MIDC',
  heading: 'eTravo: Trusted Corporate Cab Services in Talegaon Dabhade MIDC for Industries and Professionals',
  headingDescription: 'eTravo delivers dependable and organized corporate cab services in Talegaon Dabhade MIDC — one of Pune’s most prominent industrial corridors. Serving multinational companies, auto manufacturers, and logistics hubs, our transportation solutions are designed for corporate efficiency and comfort. We offer GPS-enabled vehicles, well-trained chauffeurs, and flexible shift-based cab deployment to accommodate both large and small enterprises. Whether your team needs employee transport, executive cab services, or client transfers, eTravo ensures a seamless travel experience across Talegaon MIDC and its neighboring regions.',

  top: 'Important Industrial Points in Talegaon MIDC Covered by eTravo',
  topPlaces: [
    {
      title: 'General Motors India Pvt. Ltd.',
      description: 'As one of the first major automobile manufacturing units in Talegaon MIDC, General Motors relies on timely staff movement. eTravo supports factory operations with shift-wise employee cabs, visitor transfers, and executive rides with assured punctuality.'
    },
    {
      title: 'JCB Manufacturing Facility',
      description: 'The JCB plant at Talegaon is a critical site for heavy machinery production. eTravo ensures smooth transportation for workers and engineers, maintaining structured pickup/drop schedules and minimizing downtime.'
    },
    {
      title: 'L&T Industrial Park',
      description: 'Home to several engineering and logistics companies, this park requires dependable, flexible cab service. eTravo provides tailored transport plans for daily workers, corporate executives, and visiting teams alike.'
    },
    {
      title: 'Talegaon Logistics Hub',
      description: 'This freight and warehousing zone sees high operational traffic. eTravo helps streamline transportation for logistics staff, site supervisors, and coordinators with on-demand and fixed-route cab services.'
    },
    {
      title: 'IndoSpace Industrial & Logistics Park',
      description: 'A massive warehousing and industrial estate where eTravo offers affordable and scalable cab services for growing SMEs and large corporations looking to optimize worker commutes.'
    }
  ],

  services: [
    {
      name: 'Talegaon Dabhade MIDC Corporate Cab Rentals',
      description: 'Our corporate cab rental service in Talegaon MIDC is designed for flexible business needs — from daily staff commutes to event-specific or project-based travel. We offer short-term and long-term contracts with route optimization and trained chauffeurs. The fleet includes sedans, SUVs, and vans to accommodate various group sizes. With GPS tracking, billing integration, and on-call customer support, eTravo rentals simplify transport logistics for industrial and commercial operations in the region.'
    },
    {
      name: 'Employee Transport Cab Talegaon MIDC',
      description: 'We specialize in structured employee transportation for manufacturing and logistics firms in Talegaon MIDC. eTravo’s service ensures on-time shift change transport with multi-stop route planning. Real-time vehicle tracking and driver monitoring guarantee safe and efficient commutes for workers. Whether your workforce resides in Pune, Lonavala, or nearby villages, we tailor cab routes to meet your daily operational schedule and help reduce absenteeism.'
    },
    {
      name: 'Business Cab Services Talegaon MIDC',
      description: 'Ideal for engineers, field staff, and visiting clients, our business cab service ensures professional and timely travel within Talegaon MIDC. With clean vehicles, courteous drivers, and flexible bookings, we help you maintain a productive pace across meetings and site visits. Whether it’s a one-time appointment or regular daily routing for mobile teams, our business cab service adds efficiency to your operational workflows.'
    },
    {
      name: 'Corporate Staff Cabs Talegaon MIDC',
      description: 'Companies with large headcounts and continuous operations in Talegaon MIDC benefit from our corporate staff cabs. These are tailored for factory shifts, quality control teams, logistics managers, and administrative personnel. Cabs are deployed according to shift rosters and work calendars. We ensure multi-point pickups, reduced wait times, and accurate timekeeping, boosting productivity and employee satisfaction.'
    },
    {
      name: 'Reliable Corporate Cab Service Talegaon MIDC',
      description: 'eTravo is trusted by leading industrial firms in Talegaon MIDC for providing reliable, well-maintained, and professionally operated cab services. Our strong backend technology ensures live tracking, emergency support, and automated scheduling — reducing the burden on your internal teams. Whether it’s last-minute requirements or fixed long-term travel, our systems deliver consistent reliability every day.'
    },
    {
      name: 'AC Corporate Cabs Talegaon MIDC',
      description: 'Every vehicle in our fleet is equipped with air conditioning, clean upholstery, and smooth suspension, ensuring passenger comfort even during peak heat and traffic hours. Especially useful for intercity drives or longer commutes to Pune, these AC corporate cabs offer an elevated experience for both staff and visiting executives.'
    },
    {
      name: 'Staff Pickup and Drop Cab Talegaon MIDC',
      description: 'Our staff pickup and drop services are fully customizable, based on your plant timings and employee demographics. We map routes from popular residential clusters in Pune and surrounding areas to Talegaon MIDC, reducing travel time and improving punctuality. 24/7 support is available for night shifts and early morning schedules, enhancing safety and convenience.'
    },
    {
      name: 'Affordable Business Cab Rentals Talegaon MIDC',
      description: 'For SMEs, startups, and expanding factories in Talegaon MIDC, we offer budget-friendly cab rental packages that don’t compromise on service quality. Cost-efficient vehicle plans,  options, and monthly billing cycles make it easy for small businesses to provide reliable transport to their teams. This helps improve attendance, retain workers, and elevate company reputation without increasing overheads.'
    },
    {
      name: 'Executive Cab Services Talegaon MIDC',
      description: 'Designed for CXOs, plant heads, and special guests, our executive cab services offer premium sedans, smartly dressed chauffeurs, and discreet service. From airport transfers to factory tours, we handle the logistics so you can focus on business. Expect timely arrivals, high-quality interiors, and attention to detail at every step.'
    },
    {
      name: 'Monthly Corporate Cab Rentals Talegaon MIDC',
      description: 'Our monthly rental solutions allow companies to plan staff mobility across shifts, departments, and projects. With customizable plans that include fixed or floating routes, designated vehicles, and daily tracking reports, eTravo simplifies workforce transport management. This is ideal for mid to large-sized companies aiming for consistency and accountability in their daily operations.'
    },
    {
      name: 'Industrial Area Employee Transport Talegaon MIDC',
      description: 'Talegaon MIDC’s vast industrial layout demands organized employee transport. Our services cater to factories operating multiple shifts, ensuring workers are transported safely and on time. From skilled labor to office support staff, we provide cabs that run round the clock with precise scheduling, trained drivers, and transparent monitoring.'
    },
    {
      name: 'Corporate Client Cabs Talegaon MIDC',
      description: 'Impress your clients and partners with our high-standard corporate cab services. We offer executive cars for plant visits, investor tours, and customer pickups from airports or hotels. Our chauffeurs follow formal etiquette, and vehicles are equipped for comfort and professionalism. Let eTravo enhance your business image through every ride.'
    },
    {
      name: 'Business Meeting Cabs Talegaon MIDC',
      description: 'Our business meeting cabs are ideal for swift, reliable movement between offices, factories, and industrial sites. Whether you are attending a vendor meeting, an inspection, or a client pitch, we make sure you arrive on time. These cabs can be scheduled in advance or on short notice — flexibility is our strong suit.'
    },
    {
      name: 'Talegaon Industrial Area Cab Hire',
      description: 'Need a cab for a day, week, or specific event? Our cab hire services are perfect for ad-hoc requirements, staff movements, or short-term projects. Choose from a variety of vehicles — all available with courteous drivers and optional route planning. We simplify short-term logistics for your team with ease.'
    },
    {
      name: 'Corporate Shuttle Cabs Talegaon MIDC',
      description: 'Our shuttle cab services run on predefined routes covering employee hotspots, metro stations, and residential hubs. This is the perfect solution for companies looking to manage bulk movement of workers without investing in fleet ownership. The service supports factory and warehouse operations with reliability, consistency, and reduced transport costs.'
    }
  ],

  tableData: [
    ['Talegaon Dabhade MIDC Corporate Cab Rentals', 'Employee Transport Cab Talegaon MIDC'],
    ['Business Cab Services Talegaon MIDC', 'Corporate Staff Cabs Talegaon MIDC'],
    ['Reliable Corporate Cab Service Talegaon MIDC', 'AC Corporate Cabs Talegaon MIDC'],
    ['Staff Pickup and Drop Cab Talegaon MIDC', 'Affordable Business Cab Rentals Talegaon MIDC'],
    ['Executive Cab Services Talegaon MIDC', 'Monthly Corporate Cab Rentals Talegaon MIDC'],
    ['Industrial Area Employee Transport Talegaon MIDC', 'Corporate Client Cabs Talegaon MIDC'],
    ['Business Meeting Cabs Talegaon MIDC', 'Talegaon Industrial Area Cab Hire'],
    ['Corporate Shuttle Cabs Talegaon MIDC', '']
  ],


"whychoose": [
  {
    "WhyChooseheading": "Specialized Corporate Cab Services for Talegaon Dabhade MIDC",
    "WhyChoosedescription": "eTravo offers premium, tailor-made corporate cab services designed specifically for businesses located in Talegaon Dabhade MIDC, Pune. As a key industrial hub with growing manufacturing and logistics operations, we understand the importance of reliable transportation. Our services ensure timely employee commutes, reduced operational delays, and enhanced workforce satisfaction—allowing companies to focus on their core productivity without transportation hassles."
  },
  {
    "WhyChooseheading": "Versatile Fleet for All Corporate Travel Needs",
    "WhyChoosedescription": "From sedans for executive travel to spacious MUVs for employee shuttles, our extensive vehicle fleet accommodates diverse corporate mobility requirements. Every vehicle is regularly serviced and equipped with comfort and safety features to deliver a top-tier travel experience for your staff."
  },
  {
    "WhyChooseheading": "Expert Drivers with Local Route Knowledge",
    "WhyChoosedescription": "Our professionally trained drivers are well-versed with Talegaon Dabhade MIDC’s layout and nearby industrial corridors. Their local expertise ensures optimal route selection, timely arrivals, and a smooth commute even during peak hours, making your employee transportation efficient and dependable."
  },
  {
    "WhyChooseheading": "Flexible Booking Options for Corporates",
    "WhyChoosedescription": "We understand that corporate mobility needs vary. That’s why we offer flexible booking models—whether you need on-demand cabs, scheduled pickups, or fixed long-term shuttle services. Our platform supports fast booking and scalable options to match your business operations."
  },
  {
    "WhyChooseheading": "Real-Time Tracking & Transparent Monitoring",
    "WhyChoosedescription": "All eTravo cabs are GPS-enabled, allowing real-time ride tracking for employers and passengers. This enhances accountability, improves security, and offers peace of mind to HR and operations teams responsible for employee welfare."
  },
  {
    "WhyChooseheading": "Accurate, Transparent Billing with Detailed Invoices",
    "WhyChoosedescription": "Our billing process is transparent and audit-friendly. Every invoice includes detailed trip logs, fare breakdowns, and timestamps—helping finance teams streamline expense reporting, audits, and employee reimbursements with ease."
  },
  {
    "WhyChooseheading": "Commitment to Passenger Safety & Hygiene",
    "WhyChoosedescription": "We maintain rigorous hygiene standards across our fleet. Vehicles are regularly sanitized, and drivers follow strict protocols including mask usage and wellness checks, ensuring a safe and hygienic environment for all employees, especially during shift commutes."
  },
  {
    "WhyChooseheading": "Dedicated Corporate Support & Account Management",
    "WhyChoosedescription": "Each corporate client benefits from a dedicated account manager who provides ongoing support, customizes service plans, resolves queries promptly, and ensures your transportation strategy aligns with your business goals."
  }
]
}

const faqData = [
  [
    {
      question: "Which areas are covered by your cab service in Talegaon Dabhade MIDC?",
      answer: "We provide corporate cab coverage throughout Talegaon Dabhade MIDC and nearby industrial belts, ensuring convenient access to transportation for your workforce."
    },
    {
      question: "Can we schedule daily and recurring rides for employees?",
      answer: "Yes, we offer recurring ride schedules for shift-based operations, ensuring timely and dependable transportation every day."
    },
    {
      question: "Do you offer monthly invoicing for corporate clients?",
      answer: "Absolutely. We provide monthly billing cycles with detailed invoices to simplify expense tracking and reconciliation for your finance team."
    },
    {
      question: "Are your drivers trained in professional behavior and etiquette?",
      answer: "Yes, all drivers are trained in corporate etiquette, safety procedures, and customer service best practices to ensure a pleasant experience."
    },
    {
      question: "What safety protocols are followed during cab rides?",
      answer: "We ensure every vehicle is GPS-tracked, routinely maintained, and sanitized. Drivers also follow mandatory hygiene and safety practices."
    },
    {
      question: "Is dedicated support available for corporate clients?",
      answer: "Yes, every corporate client is assigned a dedicated account manager and has access to priority support for bookings, route planning, and issue resolution."
    }
  ]
];

const testimonialsData = [
  {
    name: "Mr. Nitin Salunkhe",
    designation: "Plant Manager, AutoTech Systems",
    rating: [1, 1, 1, 1, 1],
    text: "“eTravo’s punctual and well-organized cab service has greatly benefited our employees in Talegaon Dabhade MIDC. Highly reliable and professional.”"
  },
  {
    name: "Ms. Rutuja Patankar",
    designation: "HR Executive, PrimeLogix Industries",
    rating: [1, 1, 1, 1, 1],
    text: "“Their dedicated support team and clean, safe vehicles make eTravo the ideal partner for our corporate travel needs. Our employees are more relaxed and punctual.”"
  }
];




























    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service in Talegaon Dabhade MIDC",
  "image": "https://www.etravo.in/images/keyword/cab-service-talegaon-dabhade-midc.jpg",
  "description": "Reliable and affordable corporate cab service in Talegaon Dabhade MIDC for employee transport, business meetings, and industrial area commutes. Book AC corporate cabs with experienced drivers from eTravo.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "7850"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1399",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/cab-service-talegaon-dabhade-midc"
  }
};






    return (
        <div>

<Helmet>
  <title>Cab Service in Talegaon Dabhade MIDC | Corporate & Staff Transport | eTravo</title>
  <meta 
    name="description" 
    content="Hire cab service in Talegaon Dabhade MIDC for corporate staff transport, business meetings, and industrial area commutes. Affordable and reliable AC corporate cabs by eTravo." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/64.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Cabserviceintalegaon;